// Import Core
import React from "react";
import Video from "./Video";
// Import Utils
// import { GetLinks } from '../../utils/getNavItemLinks';

const PortableTextComponent = {
  types: {
    imageItem: ({ value }) => {
      if (value.asset) {
        return (
          <div className="portable-text_image-wrapper">
            <img
              src={value.asset?.url}
              alt={value.alt}
              width={1600}
              className="portable-text_image"
            />
            <figcaption className="small">{value.caption}</figcaption>
          </div>
        );
      } else if (value.imageItem1 && value.imageItem2) {
        return (
          <div className="portable-text_image-container">
            <div className="portable-text_image-wrapper">
              <img
                src={value.imageItem1.asset.url}
                alt={value.imageItem1.alt}
                width={400}
                className="portable-text_image"
              />
              {value.captionOne ? (
                <figcaption className="small">{value.captionOne}</figcaption>
              ) : (
                ""
              )}
            </div>
            <div className="portable-text_image-wrapper">
              <img
                src={value.imageItem2.asset.url}
                alt={value.imageItem2.alt}
                width={400}
                className="portable-text_image"
              />
              {value.captionTwo ? (
                <figcaption className="small">{value.captionTwo}</figcaption>
              ) : (
                ""
              )}
            </div>
          </div>
        );
      }
    },
    // TODO:  Fix this once video component made
    video: ({ value }) => (
      <div className="portable-text_video-wrapper">
        <Video video={value} />
      </div>
    ),
    // <div><iframe src="https://player.vimeo.com/video/845250548?h=4f67207072&autoplay=1&loop=1&title=0&byline=0&portrait=0&muted=1&background=1" frameborder="0" allow="autoplay; loop=1; fullscreen; picture-in-picture" allowfullscreen></iframe></div>

    // navItem: ({value}) => <GetLinks navItem={value} />,
    // image: SampleImageComponent,
    // callToAction: ({value, isInline}) =>
    //   isInline ? (
    //     <a href={value.url}>{value.text}</a>
    //   ) : (
    //     <div className="callToAction">{value.text}</div>
    //   ),
  },

  marks: {
    link: ({ children, value }) => {
      const rel =
        value.href && !value.href.startsWith("/")
          ? "noreferrer noopener"
          : undefined;
      return (
        <a href={value.href} rel={rel}>
          {children}
        </a>
      );
    },
  },
};

export default PortableTextComponent;
